import { render, staticRenderFns } from "./Shouyou.vue?vue&type=template&id=0ee4e600&scoped=true&"
import script from "./Shouyou.vue?vue&type=script&lang=js&"
export * from "./Shouyou.vue?vue&type=script&lang=js&"
import style0 from "./Shouyou.vue?vue&type=style&index=0&id=0ee4e600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee4e600",
  null
  
)

export default component.exports